































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';

@Component
export default class AxCheckBox extends Vue {
  @Prop({ type: String, default: '' })
  label!: string;

  @PropSync('value', { type: Boolean }) syncedName!: boolean;

  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: Boolean, default: false })
  lighten!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;
}
